import { fill, zipObject } from 'lodash';
import projectStatuses from 'ProjectManager/Project/Common/constants/projectStatuses';

const defaultStatistics = zipObject(
    Object.keys(projectStatuses),
    fill(Array(Object.keys(projectStatuses).length), 0),
);

export default defaultStatistics;
